import { requestGQL } from 'common/graphQlClient';
import { gql } from 'graphql-request';

export const CREATE_DROP_ANTENNA = gql`
  mutation createDropAntenna($input: DropAntennaInput!) {
    createDropAntenna(input: $input)
  }
`;

export const createDropAntenna = (propertyId: number) => (dropAntennaDetails: any) => {
  return requestGQL(CREATE_DROP_ANTENNA, { input: { propertyId, dropAntennaDetails } });
};
